import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadIssuedLetterService {

  constructor(public http: HttpClient) { }

  public generateLetter(appId, paylaod,acronym):Observable<any>{
    return this.http.post(environment.BASE_URL_DES+`${acronym}/generateLetter/`+appId,paylaod)
  }

  public generateAdminLetter(appId, paylaod,acronym):Observable<any>{
    return this.http.post(environment.BASE_URL_DES+`${acronym}/generateAdminLetter/`+appId,paylaod)
  }

  public generateApplicantLetter(appId, acronym,isFinal):Observable<any>{
    return this.http.get(environment.BASE_URL_DES+`${acronym}/generateApplicantLetter/${appId}/${isFinal}`)
  }

  public generateBody(payload,appId):Observable<any>{
    return this.http.post(environment.BASE_URL_DAS+`desfAdmin/getLetterBody/${appId}`,payload)
  }

  public updateLetter(payload,appId):Observable<any>{
    return this.http.post(environment.BASE_URL_DAS+`desf/generateLetter/${appId}`,payload)
  }
}
